export const TERMS_URL =
  'https://www.abnamro.nl/nl/prive/abnamro/productvoorwaarden.html';
